import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import pageCover from "@/assets/kupish/p-o-nas.webp";

export const Route = createFileRoute("/o-nas")({
  head: () => {
    const url = "https://kupish.si/o-nas";
    const title = "O nas — kupish.si | spletno nakupovalno središče novih izdelkov";
    const description =
      "kupish.si je slovensko spletno nakupovalno središče novih izdelkov. Na enem mestu združuje ponudbo preverjenih spletnih trgovin in ponudnikov — od elektronike in avtoopreme do doma, mode in športa.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "sl_SI" },
        { property: "og:site_name", content: "kupish.si" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: title,
            url,
            inLanguage: "sl-SI",
            description,
            about: { "@id": "https://kupish.si/#organization" },
            speakable: { "@type": "SpeakableSpecification", cssSelector: ["h1", "[data-answer]"] },
          }),
        },
      ],
    };
  },
  component: Page,
});

function Page() {
  return (
    <section className="pb-24">
      <PageHero src={pageCover} alt="O nas — kupish.si: minimalističen 3D prikaz spletnega nakupovalnega središča novih izdelkov">
        <div className="eyebrow">O nas</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 leading-tight">
          O kupish.si — <span className=" text-accent">nakupovanje na enem mestu</span>
        </h1>
        <p data-answer className="mt-6 text-xl leading-relaxed max-w-3xl">
          kupish.si je slovensko spletno nakupovalno središče novih izdelkov. Na enem mestu združuje
          ponudbo različnih spletnih trgovin in ponudnikov — od elektronike, avdia in
          avtoopreme do drogerije, doma in vrta, mode ter športa. Kupec primerja ponudbo
          več trgovin brez preskakovanja med spletnimi stranmi, ponudnik pa dobi svojo
          trgovino znotraj nakupovalnega središča.
        </p>
      </PageHero>
      <div className="mx-auto max-w-3xl px-6">
      <div className="mt-10 space-y-6 text-lg leading-relaxed text-muted-foreground">
        <p>
          Ponudnikom omogočamo lastno spletno trgovino z letnim najemom in brez provizije
          od prodaje. Vsak ponudnik sam določa ponudbo, cene in pogoje dostave, kupec pa
          pri vsakem izdelku jasno vidi, kdo je prodajalec.
        </p>
        <p>
          Kupcem želimo prihraniti čas: pregledna struktura kategorij, primerljive
          informacije o izdelkih in en sam nakupni proces za več trgovin hkrati.
        </p>
        <p>
          Nakupovalno središče je odprto za vse slovenske trgovce in ponudnike, ki poslujejo
          transparentno in v skladu s slovensko potrošniško zakonodajo.
        </p>
        <p>
          Želite prodajati na kupish.si? Preverite{" "}
          <Link to="/najem-spletne-trgovine" className="text-accent underline underline-offset-4">
            najem spletne trgovine
          </Link>
          , kupci pa začnite pri{" "}
          <Link to="/kategorije" className="text-accent underline underline-offset-4">
            kategorijah izdelkov
          </Link>
          .
        </p>
      </div>
      </div>
    </section>
  );
}
